/** Разбор строки «город, страна» из legacy-поля location. */
export function parseCityCountry(location: string): {
    city: string;
    country: string;
} {
    const t = (location || "").trim();
    if (!t) return { city: "", country: "" };
    const comma = t.indexOf(",");
    if (comma === -1) return { city: t, country: "" };
    return {
        city: t.slice(0, comma).trim(),
        country: t.slice(comma + 1).trim(),
    };
}
